import React, { useState } from "react";
import styled from "styled-components";
import { Button, PhotoDropzone } from "../ui-kit/styled-templates";
import _ from "lodash";
import Dropzone from "../ui-kit/dropzone";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Control } from "../ui-kit/control";

export default function TripForm(props) {
    const {
        onSave = d => {

        },
        hasYandex = false,
        onDelete = () => {

        }
    } = props;

    const [name, setName] = useState(props.name || "");
    const [description, setDescription] = useState(props.description || "");
    const [topText, setTopText] = useState(props.topText || '');

    const [yandexUrl, setYandexUrl] = useState(props.yandexUrl || '');

    const [services, setServices] = useState(props.services || "");
    const [url, setUrl] = useState(props.url || "");
    const [avatar, setAvatar] = useState(props.avatar);
    const [contacts, setContacts] = useState(props.contacts || "");
    const [attachmentUrl, setAttachmentUrl] = useState(props.attachmentUrl || "");


    return (
        <Wrapper>

            <Row>
                <Control.Input
                    value={name}
                    label={"Название"} placeholder={""} isRequired
                    onChange={evt => {
                        setName(evt.target.value);
                    }}
                />
            </Row>

            <Row>
                <Control.File name="avatar" accept="image/jpeg, image/png" className={"avatar_placeholder"}
                              onChange={evt => {
                                  setAvatar(evt.target.value);
                              }}
                >
                    {avatar == undefined ? <PhotoDropzone /> :
                        <AvaImg src={avatar} />
                    }

                </Control.File>
            </Row>


            {/*<Row>*/}
            {/*    <Label>*/}
            {/*        Описание*/}
            {/*    </Label>*/}
            {/*    <ReactQuill*/}
            {/*        formats={formats}*/}
            {/*        value={description} onChange={a => {*/}
            {/*        setDescription(a);*/}
            {/*    }} />*/}
            {/*</Row>*/}

            <Row>
                <Label>
                    Описание
                </Label>
                <Textarea value={description} onChange={evt => {
                    setDescription(evt.target.value);
                }} />
            </Row>

            {hasYandex == false ? null :
                <Row>
                    <Label>
                        Ссылка на Яндекс-форму
                    </Label>
                    <Textarea value={yandexUrl} onChange={evt => {
                        setYandexUrl(evt.target.value);
                    }} />
                </Row>
            }

            {/*<Row>*/}
            {/*    <Label>*/}
            {/*        Услуги*/}
            {/*    </Label>*/}
            {/*    <Textarea value={services} onChange={evt => {*/}
            {/*        setServices(evt.target.value);*/}
            {/*    }} />*/}
            {/*</Row>*/}

            {hasYandex == true ? null :
                <Row>
                    <Label>
                        Сайт
                    </Label>
                    <Input value={url} onChange={evt => {
                        setUrl(evt.target.value);
                    }} />
                </Row>
            }


            {/*<Row>*/}
            {/*    <Control.File name="avatar" accept="application/pdf" className={"avatar_placeholder"}*/}
            {/*                  onChange={evt => {*/}
            {/*                      setAvatar(evt.target.value);*/}
            {/*                  }}*/}
            {/*    >*/}
            {/*        {avatar == undefined ? <PhotoDropzone /> :*/}
            {/*            <AvaImg src={avatar} />*/}
            {/*        }*/}

            {/*    </Control.File>*/}
            {/*</Row>*/}

            <Row>
                <Label>
                    Файл
                </Label>
                {attachmentUrl == undefined || attachmentUrl == "" ? null :
                    <div>
                        <div>
                            <a target={'_blank'} href={attachmentUrl} >скачать файл</a>
                        </div>
                        <div>
                            <span style={{cursor: 'pointer', color: 'red'}} onClick={() => {
                                setAttachmentUrl('');
                            }} >
                                удалить файл
                            </span>
                        </div>
                    </div>
                }
                <Dropzone
                    accept="image/jpeg, image/png, application/pdf"
                    extra={`width: inherit;`}
                    {..._.omit(props, [`value`, `onChange`, `dropzoneProps`])}
                    onChange={(e) => {
                        let url = e.target.value;
                        setAttachmentUrl(url);
                    }}
                >
                    <div>
                        загрузите pdf, jpg или png
                    </div>
                </Dropzone>
            </Row>

            <Row>
                <Control.Input
                    value={topText}
                    label={"Верхний текст"} placeholder={""} isRequired
                    onChange={evt => {
                        setTopText(evt.target.value);
                    }}
                />
            </Row>


            <div>
                <Button onClick={() => {
                    onSave({
                        name,
                        avatar,
                        description,
                        contacts,
                        services,
                        url,
                        attachmentUrl,
                        yandexUrl,
                        topText
                    });
                }}>
                    Сохранить
                </Button>
            </div>

            <div style={{ marginTop: 20, marginBottom: 20 }}>
                <DeleteSpan onClick={() => {
                    onDelete();
                }}>
                    Удалить
                </DeleteSpan>
            </div>

        </Wrapper>
    );
}

const DeleteSpan = styled.div`
  cursor: pointer;
  color: red;
  opacity: 0.7;

  :hover {
    opacity: 1;
  }
`;


const Wrapper = styled.div`

`;

const AvaImg = styled.img`
  //height: 400px;
`;


const Row = styled.div`
  margin-bottom: 10px;
`;

const Label = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  outline: none;
  border: 1px solid whitesmoke;

  :focus {
    border-color: blue;
  }
`;

const Textarea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  outline: none;
  border: 1px solid whitesmoke;

  :focus {
    border-color: blue;
  }
`;